<template>
  <div class="whatsapp-button">
    <v-btn
      class="px-4"
      color="#25D366"
      :href="link"
      target="_blank"
      min-width="auto"
      height="44px"
      rounded
    >
      <v-icon size="24" color="white">fab fa-whatsapp</v-icon>

      <span class="text-body-1 text-none ml-2 white--text font-weight-medium">
        {{ text }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "Fale conosco",
    },
  },
  data: () => ({
    menu: false,
  }),
};
</script>

<style>
.whatsapp-button {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: max-content;
  z-index: 99999;
}
</style>
